import { HashRouter as Router, Route, useHistory } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import Header from "@Header";
import Footer from "@Footer";
import Toast from "@Comp/Toast";
import routesJson from '@LayOut/Routes/Routes.json'
import React, { Suspense, useState, useEffect } from 'react';

import Main from '@App/Main/Main';
import Login from '@App/Login/Login';
import AuthKeyApply from '@Views/app/AuthKeyApply/AuthKeyApply';
import PasswordFind from '@Views/app/Login/comp/PasswordFind';

const Routes = () => {
  const { t } = useTranslation();
  const userInfoSession: any = sessionStorage.getItem("userInfo");
  const [userInfo, setUserInfo]: any = useState(JSON.parse(userInfoSession));

  const getMsg = (url?: string) => {
    const comMsg = { "comMsg": t("comMsg", { returnObjects: true, }) };

    if (url) {
      return Object.assign(t(url, { returnObjects: true }), comMsg['comMsg']);
    } else {
      return comMsg['comMsg'];
    }
  }

  const getRoute = () => {
    const result: any = [];
    const json: any = routesJson;

    for (const key of Object.keys(json)) {
      const url = json[key]['url'];

      const subMenu = json[key]['menu'];

      if (subMenu) {

        for (const item of subMenu) {
          const menuUrl = url + '/' + item['url'];
          const Comp = React.lazy(() => import('@Views/app/' + menuUrl));
          const path = '/' + menuUrl;


          if (item['params']) {
            for (const param of item['params']) {
              const paramPath = path + param;
              result.push(<Route exact key={paramPath} path={paramPath} render={() => <Comp url={menuUrl} msg={getMsg(menuUrl)} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
            }
          }

          result.push(<Route key={path} exact path={path} render={() => <Comp url={menuUrl} msg={getMsg(menuUrl)} userInfo={userInfo} setUserInfo={setUserInfo} />} />);


        }
      } else {
        const Comp = React.lazy(() => import('@Views/app/' + url + '/' + url));
        const menuUrl = url + '/' + url;
        result.push(<Route key={url} exact path={'/' + url} render={() => <Comp url={menuUrl} msg={getMsg(menuUrl)} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
      }
    }

    result.push(<Route key="Main" exact path="/" render={() => <Main msg={getMsg("Main/Main")} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
    result.push(<Route key="Login/:pageUrl*" exact path="/Login/:pageUrl*" render={() => <Login msg={getMsg("Login/Login")} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
    result.push(<Route key="PasswordFind" exact path="/PasswordFind" render={() => <PasswordFind msg={getMsg("Login/PasswordFind")} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
    result.push(<Route key="AuthKeyApply" exact path="/AuthKeyApply" render={() => <AuthKeyApply msg={getMsg("AuthKeyApply/AuthKeyApply")} userInfo={userInfo} setUserInfo={setUserInfo} />} />);

    return result;
  }

  const Loading = () => {
    return (
      <div className="loading displayNone">
        <div className="loading-visual">
          <div className="image">
            <div className="spinner">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <p className="text">Loading ...</p>
        </div>

        <div className="loading-dim"></div>
      </div>
    )
  }

  return (
    <>
      <Toast getMsg={getMsg} />
      <Loading />
      <Router >
        <Header getMsg={getMsg} routesJson={routesJson} userInfo={userInfo} setUserInfo={setUserInfo} />

        <Suspense fallback={<><Loading /></>}>
          {getRoute()}
        </Suspense>

        <Footer getMsg={getMsg} />
      </Router>

    </>
  )
}


export default Routes;